import React, { useEffect, useState } from 'react';
import { TextField, Typography, Snackbar } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import api from '../api';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MuiAlert from '@material-ui/lab/Alert';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import CustomTextField from '../components/customTextField';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function AddAmbulance(props) {
    const [bookingDate, setBookingDate] = React.useState(new Date());

    const [nama, setNama] = useState("")
    const [lisence, setLisence] = useState("")
    const [errorNama, setErrorNama] = React.useState(false);
    const [errorLisence, setErrorLisence] = React.useState(false);
    const [texterrorNama, setTextErrorNama] = React.useState(null);
    const [textErrorLisence, setTextErrorLisence] = React.useState(null);

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleSave = () => {
        if (nama === "") {
            setErrorNama(true)
            setTextErrorNama("Nama wajib diisi")
        } else if (lisence === "") {
            setErrorLisence(true)
            setTextErrorLisence("Lisence wajib diisi")
        } else {
            let payload = {
                "vehicle_name": nama,
                "vehicle_number": lisence
            }
            props.createAmbulance(payload)
        }
    }

    return (
        <div className="App app-popup-show">
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Order Ambulance</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>
                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                    <div className="column-1">
                        <div className="margin-bottom-20px" style={{ marginTop: 8 }}>
                            <CustomTextField
                                required={true}
                                label={"Nama Mobil"}
                                value={nama}
                                error={errorNama}
                                helperText={texterrorNama}
                                onChange={(val) => {
                                    setErrorNama(false)
                                    setTextErrorNama("")
                                    setNama(val)
                                }}
                            />
                        </div>
                    </div>
                    <div className="column-2">
                        <div className="margin-bottom-20px" style={{ marginTop: 8 }}>
                            <CustomTextField
                                required={true}
                                label={"Lisence"}
                                value={lisence}
                                error={errorLisence}
                                helperText={textErrorLisence}
                                onChange={(val) => {
                                    setErrorLisence(false)
                                    setTextErrorLisence("")
                                    setLisence(String(val).toLocaleUpperCase())
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => handleSave()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}